import { render, staticRenderFns } from "./BrbImagePreview.vue?vue&type=template&id=2d64da31&"
import script from "./BrbImagePreview.vue?vue&type=script&lang=js&"
export * from "./BrbImagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d64da31')) {
      api.createRecord('2d64da31', component.options)
    } else {
      api.reload('2d64da31', component.options)
    }
    module.hot.accept("./BrbImagePreview.vue?vue&type=template&id=2d64da31&", function () {
      api.rerender('2d64da31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbImagePreview.vue"
export default component.exports